var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-auto"},[_c(_setup.VVerificationRequiredOverlay),_c(_setup.TitledProgressStepper,{staticClass:"mb-lg",attrs:{"steps":_setup.steps}}),_c(_setup.DocumentsScreen)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }